import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex h-full items-center justify-center p-4 sm:p-8" }

import { computed } from 'vue'
import { useStore } from 'vuex'

import FranchiseMenuControls from '@/components/franchise/FranchiseMenuControls.vue'
import FranchiseMenuSetupCard from '@/components/franchise/FranchiseMenuSetupCard.vue'
import FranchiseMerchantSwitcher from '@/components/franchise/FranchiseMerchantSwitcher.vue'
import EmptyState from '@/components/neue/EmptyState.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { blueprintIdOf } from '@/helpers/franchiseMerchant'
import ProductList from '@/view/store/ProductList.vue'


export default {
  __name: 'FranchiseProductLibrary',
  setup(__props) {

const store = useStore()
const activeMerchantId = computed(() => store.state.activeFranchiseMerchantId)
// With no location chosen and no franchise menu yet, the switcher reads "Franchise menu" and this offers to set it up.
const blueprintId = computed(() => blueprintIdOf(store.state))

return (_ctx, _cache) => {
  return (activeMerchantId.value)
    ? (_openBlock(), _createBlock(ProductList, {
        key: activeMerchantId.value,
        "compact-header": ""
      }, {
        right: _withCtx(() => [
          _createVNode(FranchiseMenuControls),
          _createVNode(FranchiseMerchantSwitcher, {
            "include-all": false,
            "include-blueprint": ""
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(SecondaryNav, { key: 1 }, {
        top: _withCtx(() => [
          _createVNode(SecondaryTop, { text: "Product library" }, {
            right: _withCtx(() => [
              _createVNode(FranchiseMenuControls),
              _createVNode(FranchiseMerchantSwitcher, {
                "include-all": false,
                "include-blueprint": ""
              })
            ]),
            _: 1
          })
        ]),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!blueprintId.value)
              ? (_openBlock(), _createBlock(FranchiseMenuSetupCard, { key: 0 }))
              : (_openBlock(), _createBlock(EmptyState, {
                  key: 1,
                  plural: "products",
                  description: "Choose a location to see its product library"
                }))
          ])
        ]),
        _: 1
      }))
}
}

}